// src/features/owner/charts/ComboChart.tsx — new-users bars + cumulative line, empty-aware.
import styled, { useTheme } from 'styled-components';
import type { GrowthPoint } from '@/core/models';

const Empty = styled.p`
  color: ${({ theme }) => theme.color.textMuted};
  font-size: ${({ theme }) => theme.fontSize.sm};
  text-align: center;
  padding: 24px 0;
`;

export function ComboChart({
  points,
  ariaLabel,
}: {
  points: GrowthPoint[];
  ariaLabel: string;
}) {
  const theme = useTheme();
  const maxBar = Math.max(1, ...points.map((p) => p.newUsers));
  const maxCum = Math.max(1, ...points.map((p) => p.cumulative));

  if (points.every((p) => p.newUsers === 0 && p.cumulative === 0)) {
    return <Empty>Not enough data yet</Empty>;
  }

  const W = 340;
  const H = 140;
  const n = points.length;
  const bw = (W / n) * 0.5;

  const line = points
    .map((p, i) => `${(i + 0.5) * (W / n)},${H - (p.cumulative / maxCum) * (H - 20) - 6}`)
    .join(' ');

  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" height={H} role="img" aria-label={ariaLabel}>
      {points.map((p, i) => {
        const h = (p.newUsers / maxBar) * (H - 30);
        const x = (i + 0.5) * (W / n) - bw / 2;
        return (
          <rect
            key={p.date}
            x={x}
            y={H - h}
            width={bw}
            height={h}
            rx="3"
            fill={theme.color.brandFrom}
            opacity="0.7"
          />
        );
      })}
      <polyline points={line} fill="none" stroke={theme.color.brandTo} strokeWidth="2" />
    </svg>
  );
}
